var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"base-button-type-1",class:{ blue: _vm.typeColor == 'blue', white: _vm.typeColor == 'white' },domProps:{"textContent":_vm._s(_vm.text)}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }